import './TeamsInfo.scss'

import {LinkType, WysiwygType} from '../../../types'

import {MarkedTitle} from '../../ui/MarkedTitle'
import React from 'react'
import {Theme} from '../../Theme'
import {dateFromServerDate} from '../../../util/dates'
import isWithinInterval from 'date-fns/isWithinInterval'
import {number_format} from '../../../util/price'
import {style} from '../../../util/style'
import {useTranslation} from '../../../util/i18n'

const styles = style('teamsinfo', ['register'])

export type TeamsInfoType = {
	money?: number
	numberOfTeams?: number
	registration?: TeamsInfoRegisterType
	message?: string
}

export type TeamsInfoRegisterType = {
	title?: string
	text?: WysiwygType
	button?: LinkType
	date_start: string
	date_end: string
}

export const TeamsInfo: React.FC<TeamsInfoType> = ({
	money,
	numberOfTeams,
	registration,
	message
}) => {
	const t = useTranslation('teams').overview.info
	const text =
		message ||
		(numberOfTeams === 1
			? t.was_gathered_by_single
			: t.was_gathered_by.replace('{{numberOfTeams}}', `${numberOfTeams}`))
	return (
		<div className={styles()}>
			<Theme.Container>
				<div className={styles('row')}>
					<div className={styles('info')}>
						<MarkedTitle
							title={`€${number_format(money, 2, ',', '.')}`}
							direction="left"
						/>
						<p className={styles('info-text')}>{text}</p>
					</div>
					<TeamsInfoRegister {...registration} />
				</div>
			</Theme.Container>
		</div>
	)
}

const TeamsInfoRegister: React.FC<TeamsInfoRegisterType> = ({
	title,
	text,
	button,
	date_start,
	date_end
}) => {
	if (!title && !text && !button) return null

	let todayIsInInterval = false
	if (date_start && date_end) {
		const todayDate = new Date()
		const startServerDate = dateFromServerDate(date_start)
		const endServerDate = dateFromServerDate(date_end)

		todayIsInInterval = isWithinInterval(todayDate, {
			start: startServerDate,
			end: endServerDate
		})
	}

	if (!todayIsInInterval) return null

	return (
		<div className={styles.register()}>
			<div className={styles.register('row')}>
				<div className={styles.register('content')}>
					{title && (
						<Theme.H3 className={styles.register('content-title')}>
							{title}
						</Theme.H3>
					)}
					{text && (
						<div className={styles.register('content-text')}>
							<Theme.Wysiwyg>{text}</Theme.Wysiwyg>
						</div>
					)}
				</div>
				{button?.url && (
					<div className={styles.register('button')}>
						<Theme.Button
							to={button.url}
							mod={['outline', 'whitebg']}
							withIcon="arrow"
						>
							{button.description || button.title}
						</Theme.Button>
					</div>
				)}
			</div>
		</div>
	)
}
